export default __webpack_public_path__ + "static/media/availability-tile.149b1e6a.png";